// IP-15330: the rename request's param key, on its own so it can be asserted
// without pulling in the axios instance (which needs a CSRF meta tag at import).
//
// Settings::TagsController reads `params.require(:tag)`. The ERB form this
// replaced derived its key from the model class and submitted
// `acts_as_taggable_on_tag[name]`, which the controller ignored — the rename
// silently did nothing. Naming the key once, with a test on it, is what keeps
// that from coming back now the form is React.
export const RENAME_PARAM_KEY = 'tag';

export const renamePayload = (name) => ({ [RENAME_PARAM_KEY]: { name } });
